import api from '../api';
import { SchemaVariant } from '@morph-mapper/types';

// Rendering sends the complete document to the engine and may legitimately
// take longer than a normal CRUD request for large spreadsheet inputs.
const RENDER_TIMEOUT_MS = 120_000;

export const renderTemplate = async (
  variant: SchemaVariant,
  template: any,
  targetContent: string,
  options: any,
  signal?: AbortSignal,
): Promise<any> => {
  const { data } = await api.post(
    'engine/template/render',
    {
      variant,
      template,
      targetContent,
      options,
    },
    { timeout: RENDER_TIMEOUT_MS, signal },
  );
  return data;
};

export const parseFile = async (
  variant: SchemaVariant,
  file: File,
): Promise<string> => {
  const form = new FormData();
  form.append('variant', variant);
  form.append('file', file);

  const { data } = await api.post('engine/file/parse', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    timeout: 60_000,
  });

  return data;
};
